import './PudoMarkerIcon.css';

interface PudoMarkerIconProps {
  viewBox: number;
  stopOrder: number;
  color: string;
}

const PudoMarkerIcon = ({ stopOrder, viewBox, color }: PudoMarkerIconProps) => {
  const centerX = viewBox / 2;
  const centerY = viewBox / 2;
  const circleRadius = 10;

  const badgeX = centerX + circleRadius * 1.2;
  const badgeY = centerY - circleRadius * 1.2;

  return (
    <svg
      className="pudo-svg"
      viewBox={`0 0 ${viewBox} ${viewBox}`}
      width={viewBox}
      height={viewBox}
    >
      <circle
        cx={centerX}
        cy={centerY}
        r={circleRadius}
        fill="white"
        stroke={color}
        strokeWidth={4}
      />

      <text
        x={centerX}
        y={centerY}
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize="8"
        fontWeight="regular"
        fill="black"
      >
        {stopOrder}
      </text>

      <g transform={`translate(${badgeX}, ${badgeY}) scale(1.5)`}>
        <circle
          cx="0"
          cy="0"
          r="5"
          fill="white"
          stroke={color}
          strokeWidth="2"
        />

        <g transform="scale(0.7)">
          <rect
            x="-3"
            y="-1.5"
            width="6"
            height="5"
            fill="none"
            stroke={color}
            strokeWidth="0.8"
            rx="0.3"
          />
          <path
            d="M -3.5 -1.5 L -3.5 -3 L 3.5 -3 L 3.5 -1.5"
            fill="none"
            stroke={color}
            strokeWidth="0.8"
            strokeLinejoin="round"
          />
          <line
            x1="-2.5"
            y1="-3"
            x2="-2.5"
            y2="-1.5"
            stroke={color}
            strokeWidth="0.5"
          />
          <line
            x1="-1"
            y1="-3"
            x2="-1"
            y2="-1.5"
            stroke={color}
            strokeWidth="0.5"
          />
          <line
            x1="0.5"
            y1="-3"
            x2="0.5"
            y2="-1.5"
            stroke={color}
            strokeWidth="0.5"
          />
          <line
            x1="2"
            y1="-3"
            x2="2"
            y2="-1.5"
            stroke={color}
            strokeWidth="0.5"
          />
          <rect
            x="-1"
            y="0"
            width="2"
            height="3.5"
            fill="none"
            stroke={color}
            strokeWidth="0.6"
            rx="0.2"
          />
          <circle cx="0.2" cy="1.5" r="0.35" fill={color} />
        </g>
      </g>
    </svg>
  );
};

export default PudoMarkerIcon;
